/**
 * @module RouteActivationGuard
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteActivationGuardService {
  constructor() {}
  /**
   * Checks whether current route is permissable.
   * Based on results it deletes previous created  line.
   * @returns Observable of boolean.
   */
  public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    // const customerConfigData: BrowseEntry = this.stateStoreUtilsService.getCustomerConfigData();
    // if (billingType === PRODUCT_SELECTOR_CONSTANTS.BILLING_TYPE) {
    //   return this.cartSupportService.deleteLine(currentLineInFocus).
    //   map((cart: Cart) => {
    //       return true;
    //   });
    // }
    // else {
    //   return true;
    // }
    return true;
  }
}
